import React, { useEffect } from "react";
import Image1 from '../../assets/images/banner-feature-img-1.png'
import Image2 from '../../assets/images/banner-feature-img-2.png'
import Image3 from '../../assets/images/banner-feature-img-3.png'
import Image4 from '../../assets/images/banner-feature-img-4.png'
import Image5 from '../../assets/images/banner-feature-img-5.png'
import Image6 from '../../assets/images/banner-feature-img-6.png'
import AOS from 'aos';
import 'aos/dist/aos.css';
function Bannerfeature() {
  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: false,
    });
  }, []);
  return (
    <>
      <section className="banner_feature pt-5 pb-5 " style={{marginTop:'-40px'}}>
        <div className="container">
          <div className="row">
            <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6  grid_col">
              <div className="inner-box-main" style={{ backgroundColor: '#D6E4FF' }} data-aos="zoom-in">
                <div className="inner-box" style={{ border: '2px dashed #799CDE' }}>
                  <img src={Image1} alt="img" />
                  <h6 style={{ color: '#799CDE' }}>Medicinal Properties</h6>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6 grid_col">
              <div className="inner-box-main" style={{ backgroundColor: '#FFCCCC' }} data-aos="zoom-in">
                <div className="inner-box" style={{ border: '2px dashed #BF6B6B' }}>
                  <img src={Image2} alt="img" />
                  <h6 style={{ color: '#BF6B6B' }}>Environment Friendly</h6>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6 grid_col">
              <div className="inner-box-main" style={{ backgroundColor: '#FFE5BD' }} data-aos="zoom-in">
                <div className="inner-box" style={{ border: '2px dashed #C1985B' }}>
                  <img src={Image3} alt="img" />
                  <h6 style={{ color: '#C1985B' }}>Natural Color</h6>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6 grid_col">
              <div className="inner-box-main" style={{ backgroundColor: '#CCECEC' }} data-aos="zoom-in">
                <div className="inner-box" style={{ border: '2px dashed #62B0B0' }}>
                  <img src={Image4} alt="img" />
                  <h6 style={{ color: '#62B0B0' }}>Sustainable </h6>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6 grid_col">
              <div className="inner-box-main" style={{ backgroundColor: '#F5DCED' }} data-aos="zoom-in">
                <div className="inner-box" style={{ border: '2px dashed #B584A5' }}>
                  <img src={Image5} alt="img" />
                  <h6 style={{ color: '#B584A5' }}>Gender Neutral</h6>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6 grid_col">
              <div className="inner-box-main" style={{ backgroundColor: '#F5C3A3' }} data-aos="zoom-in">
                <div className="inner-box" style={{ border: '2px dashed #A87554' }}>
                  <img src={Image6} alt="img" />
                  <h6 style={{ color: '#A87554' }}>GOTS Certified organic cotton</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Bannerfeature;
